(() => {
  const main = document.querySelector('#MainContent:is(.template-product, .template-product-sticky-cta-test)');
  const buyBox = main?.querySelector('.product-top');
  if (!main || !buyBox) return;

  const updateBackgroundStart = () => {
    const mainBounds = main.getBoundingClientRect();
    const buyBoxBounds = buyBox.getBoundingClientRect();
    main.style.setProperty('--pdp-background-start', `${Math.max(0, Math.ceil(buyBoxBounds.bottom - mainBounds.top))}px`);
  };

  updateBackgroundStart();
  const observer = new ResizeObserver(updateBackgroundStart);
  observer.observe(buyBox);
  observer.observe(main);
})();
